module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    class: [{
      indeterminate: _vm.isIndeterminate
    }, _vm.classes],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "indeterminate": _vm.isIndeterminate,
      "checked": _vm.isChecked
    },
    on: {
      "change": _vm.toggle
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01e79ee8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/revenue/Checkbox.vue
// module id = 2722
// module chunks = 0